import { useTranslation } from "react-i18next";
import {
  Box,
  SpanStyled,
  SubHeadingStyled,
} from "../../../../components/styled/Elements";
import { FormRadioWrapper } from "./AccessSettings";
import { Field, ErrorMessage, useFormikContext } from "formik";
import useCabinetOptions from "../../../../hooks/useCabinetOptions";
import AddSingleDepartment from "../../../../components/common/modals/singleDepartmentModal/AddSingleDepartment";
import { Plus } from "../../../../components/styled/AllImages";
import { useDispatch, useSelector } from "react-redux";
import AddMultipleDepartments from "../../../../components/common/modals/multipleDepartmentsModal/AddMultipleDepartments";
import { useEffect, useState } from "react";
import AddMultipleUsersBranchDep from "./AddMultiUsersBranchDep";
import { setUsersList } from "../../../../store/slices/helperSlice";

const OtherDepartmentOptions = () => {
  const { t, i18n: { language } } = useTranslation();
  const dispatch = useDispatch();
  const { setFieldValue, values } = useFormikContext();
  const { otherDepartments, refetch } = useCabinetOptions();
  const { usersList, branchesDeps, hqBranchesList } = useSelector(
    (state) => state.helper,
  );

  const [userSelections, setUserSelections] = useState({
    branch_ids: values?.from_branches ?? [],
    department_ids: [],
    user_ids: [],
  });

  useEffect(() => {
    let formattedUsersList = usersList.map((usr) => {
      const uKey = `other_department_${usr.id}`;
      
      const existingReferral = values.referrals?.find(
        (ref) => ref.unique_id === uKey
      );

      return {
        ...usr,
        referralNote: existingReferral ? existingReferral.note : "",
        referralUniqueKey: uKey,
        shareReferrals: !!existingReferral,
      };
    });
    dispatch(setUsersList(formattedUsersList));
  }, []);

  useEffect(() => {
    refetch();
  }, [language]);

  return (
    <Box className="optionsContent">
      <SubHeadingStyled
        size="15px"
        weight={700}
        color={"var(--text)"}
        className="px-4 pt-4 pb-0"
      >
        {t("other_department")}
      </SubHeadingStyled>

      <Box className="w-100 p-2">
        {otherDepartments.map((option, i) => (
          <Box
            key={option.id || i}
            className={`w-100 p-2 ${
              i !== otherDepartments.length - 1 ? "separation-border" : ""
            }`}
          >
            <FormRadioWrapper>
              <Field
                type="radio"
                name="other_department_id"
                className="radio-input"
                value={option.id}
                checked={values.other_department_id === option.id}
                onChange={(e) => {
                  setFieldValue("other_department_id", Number(e.target.value));
                  setFieldValue("other_dept_ids", []);
                  setFieldValue("setting_id", null);
                }}
              />

              <SpanStyled
                size="16px"
                color="var(--text)"
                checked={values.other_department_id === option.id}
                className="radio-label"
              >
                {t(option.title)}
              </SpanStyled>
            </FormRadioWrapper>
            {values.other_department_id === option.id &&
              values.other_department_id === 6 && (
                <>
                  <AddSingleDepartment
                    title="select_department"
                    icon={<Plus />}
                    selPlaceholder="Select_One_Department"
                    mainParents={branchesDeps}
                    selectedItem={values?.other_dept_ids}
                    setSelectedItem={(newIds) => {
                      const formattedIds = Array.isArray(newIds) ? newIds : [newIds];
                      setFieldValue('other_dept_ids', formattedIds);
                    }}
                  />
                  <ErrorMessage
                    name="other_dept_ids"
                    component="div"
                    className="text-danger text-sm mb-0 mt-1"
                  />
                </>
              )}
            {values.other_department_id === option.id &&
              values.other_department_id === 7 && (
                <>
                  <AddMultipleDepartments
                    title="select_department"
                    icon={<Plus />}
                    selPlaceholder="select_department"
                    mainParents={branchesDeps}
                    selectedIds={values.other_dept_ids}
                    setSelectedIds={(newIds) => {
                      setFieldValue('other_dept_ids', newIds);
                    }}
                  />
                  <ErrorMessage
                    name="other_dept_ids"
                    component="div"
                    className="text-danger text-sm mb-0 mt-1"
                  />
                </>
              )}
            {values.other_department_id === option.id &&
              values.other_department_id === 8 && (
                <>
                  <AddMultipleUsersBranchDep
                    title="select_department"
                    icon={<Plus />}
                    selPlaceholder="SelectUser"
                    checkedUsers={values?.checkedUsers ?? []}
                    checkedHqBranches={values?.checkedHqBranches ?? []}
                    // mainParents={branchesDeps}
                    selectedIds={values?.other_dept_ids ?? []}
                    setSelectedIds={(newIds) => {
                      setFieldValue('other_dept_ids', newIds);
                    }}
                    hqBranchesList={hqBranchesList}
                    usersList={usersList}
                    branchesDeps={branchesDeps}
                    userSelections={userSelections}
                    setUserSelections={(selections) => {
                      setUserSelections(selections);
                      if (selections.user_ids?.length > 0) {
                        setFieldValue('other_dept_ids', selections.user_ids);
                        setFieldValue('from_branches', selections.branch_ids);
                        setFieldValue('from_departments', selections.department_ids);
                      }
                    }}
                  />
                  <ErrorMessage
                    name="other_dept_ids"
                    component="div"
                    className="text-danger text-sm mb-0 mt-1"
                  />
                </>
              )}
            {values.other_department_id === option.id &&
              values.other_department_id === 9 && (
                <>
                  <AddMultipleUsersBranchDep
                    title="select_department"
                    icon={<Plus />}
                    selPlaceholder="SelectUser"
                    checkedUsers={values?.checkedUsers ?? []}
                    checkedHqBranches={values?.checkedHqBranches ?? []}
                    // mainParents={branchesDeps}
                    // setSelectedIds={(ids) => {
                    //   field.onChange(ids);
                    //   setSelectedIds(ids);
                    // }}
                    selectedIds={values?.other_dept_ids ?? []}
                    setSelectedIds={(newIds) => {
                      setFieldValue('other_dept_ids', newIds);
                    }}
                    hqBranchesList={hqBranchesList}
                    usersList={usersList}
                    branchesDeps={branchesDeps}
                    userSelections={userSelections}
                    setUserSelections={(selections) => {
                      setUserSelections(selections);
                      if (selections.user_ids?.length > 0) {
                        setFieldValue('other_dept_ids', selections.user_ids);
                        setFieldValue('from_branches', selections.branch_ids);
                        setFieldValue('from_departments', selections.department_ids);
                      }
                    }}
                  />
                  <ErrorMessage
                    name="other_dept_ids"
                    component="div"
                    className="text-danger text-sm mb-0 mt-1"
                  />
                </>
              )}
          </Box>
        ))}

        {/* ✅ ERROR MESSAGE */}
        <ErrorMessage
          name="other_department_id"
          component="div"
          className="text-danger text-sm mb-0 mt-1"
        />
      </Box>
    </Box>
  );
};

export default OtherDepartmentOptions;
